import { useState } from 'react';
import { isIpSubnetValid } from '../../../../../components/utils';

const addIpsFromFile = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        const ipList = [];

        fileReader.onload = (e) => {
            const fileContent = e.target.result;
            const ips = fileContent.split(',');

            for (const ip of ips) {
                if (isIpSubnetValid(ip)) {
                    ipList.push(ip);
                }
            }
            resolve(ipList);
        };

        fileReader.onerror = (e) => {
            reject(e);
        };

        fileReader.readAsText(file);
    });
};

const useGetIpListFromFile = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getIpListFromFile = async (file) => {
        setIsLoading(true);
        try {
            const response = await addIpsFromFile(file);
            return response;
        } catch (error) {
            setError("Couldn't upload the file");
        } finally {
            setIsLoading(false);
        }
    };

    return { getIpListFromFile, isLoading, error };
};

export default useGetIpListFromFile;
